import Request from '@/api/request';
// 获取功能模块名称列表
export function getOperateModulesList(params) {
  return Request('/operateLog/listModules', {
    method: 'POST',
    data: params,
  });
}
// 操作日志分页
export function getOperateLogList(params) {
  return Request('/operateLog/list', {
    method: 'POST',
    data: params,
  });
}
// 操作日志详情
export function getOperateLogById(params) {
  return Request('/operateLog/get', {
    method: 'POST',
    data: params,
  });
}
// 根据传入的参数名获取对应配置
export function getConfigByNames(params) {
  return Request('/sysConfig/getByNames', {
    method: 'POST',
    data: params,
  });
}
// 提交参数名及对应的值，保存到系统配置
export function saveConfigByNames(params) {
  return Request('/sysConfig/saveByNames', {
    method: 'POST',
    data: params,
  });
}
//  获取所有品牌到账天数
export function getChannelSplitDays(params) {
  return Request('/sysConfig/getChannelSplitDays', {
    method: 'GET',
    data: params,
  });
}

// 提交品牌及对应的值，保存到系统配置
export function saveChannelSplitDay(params) {
  return Request('/sysConfig/saveChannelSplitDay', {
    method: 'POST',
    data: params,
  });
}
// 修改密码
export function modifyPassword(params) {
  return Request('/entrance/modifyPsw', {
    method: 'POST',
    data: params,
  });
}
// 设置分账顺序 sysConfig/sortVendorChannelType
export function sortVendorChannelType(params) {
  return Request('/sysConfig/sortVendorChannelType', {
    method: 'POST',
    data: params,
  });
}
// 获取品牌列表分页
export function getTradeChannelListPage(params) {
  return Request('/tradeChannel/list', {
    method: 'POST',
    data: params,
  });
}
// 获取品牌详情
export function getTradeChannel(params) {
  return Request('/tradeChannel/get', {
    method: 'POST',
    data: params,
  });
}
// 保存品牌
export function saveTradeChannel(params) {
  return Request('/tradeChannel/save', {
    method: 'POST',
    data: params,
  });
}
// 删除品牌
export function delTradeChannel(params) {
  return Request('/tradeChannel/delete', {
    method: 'POST',
    data: params,
  });
}
// 获取大区列表分页
export function getTradeAreaListPage(params) {
  return Request('/tradeArea/list', {
    method: 'POST',
    data: params,
  });
}
//复制分账信息
export function copydivideFeeTypeConfig(params) {
    return Request('/divideFeeTypeConfig/copy', {
      method: 'POST',
      data: params,
    });
  }
// 获取大区详情
export function getTradeArea(params) {
  return Request('/tradeArea/get', {
    method: 'POST',
    data: params,
  });
}
// 保存大区
export function saveTradeArea(params) {
  return Request('/tradeArea/save', {
    method: 'POST',
    data: params,
  });
}
// 删除大区
export function delTradeArea(params) {
  return Request('/tradeArea/delete', {
    method: 'POST',
    data: params,
  });
}
// /tradeArea/trees 门店列表树状结构
export function getTradeAreaTrees(params) {
  return Request('/tradeArea/trees', {
    method: 'POST',
    data: params,
  });
}
// 获取区域列表分页
export function getTradeRangeListPage(params) {
  return Request('/tradeRange/list', {
    method: 'POST',
    data: params,
  });
}
// 获取区域详情
export function getTradeRange(params) {
  return Request('/tradeRange/get', {
    method: 'POST',
    data: params,
  });
}
// 保存区域
export function saveTradeRange(params) {
  return Request('/tradeRange/save', {
    method: 'POST',
    data: params,
  });
}
// 删除区域
export function delTradeRange(params) {
  return Request('/tradeRange/delete', {
    method: 'POST',
    data: params,
  });
}
// /icbc/image/upload 商户注册上传图片
export function uploadImage(params) {
  return Request('/icbc/image/upload', {
    method: 'POST',
    data: params,
  });
}
// /icbc/image/download 商户注册下载图片
export function downloadImage(params) {
  return Request('/icbc/image/download', {
    method: 'POST',
    data: params,
  });
}
// 根据传入的mchntld 获取对应的资金类型或角色类型

export function getByNameAndType(params) {
  return Request('/sysConfig/getByNameAndType', {
    method: 'POST',
    data: params,
  });
}

// 发送短信 corporLink/transfer/sendMsg
export function sendsms(params) {
  return Request('/corporLink/transfer/sendMsg', {
    method: 'POST',
    data: params,
  });
}

// /vendorType/list 门店类型列表
export function getVendorTypeListPage(params) {
  return Request('/vendorType/list', {
    method: 'POST',
    data: params,
  });
}
// /vendorType/export 门店类型导出
export function exportVendorType(params) {
  return Request('/vendorType/export', {
    method: 'POST',
    data: params,
  });
}
// /vendorType/get 门店类型详情
export function getVendorType(params) {
  return Request('/vendorType/get', {
    method: 'POST',
    data: params,
  });
}
// /vendorType/save 门店类型详情
export function saveVendorType(params) {
  return Request('/vendorType/save', {
    method: 'POST',
    data: params,
  });
}
// /vendorType/listNames 门店类型搜索列表
export function getVendorTypeListNames(params) {
  return Request('/vendorType/listNames', {
    method: 'POST',
    data: params,
  });
}
// /vendorType/delete 搜索列表 参数：idArr:[1,2]
export function deleteVendorType(params) {
  return Request('/vendorType/delete', {
    method: 'POST',
    data: params,
  });
}

// 分账费项管理
// divideFeeType/get -详情 参数id
export function getDivideFeeType(params) {
  return Request('/divideFeeType/get', {
    method: 'POST',
    data: params,
  });
}
// divideFeeType/list
export function getDivideFeeTypeListPage(params) {
  return Request('/divideFeeType/list', {
    method: 'POST',
    data: params,
  });
}
// divideFeeType/save — 新增,修改
export function saveDivideFeeType(params) {
  return Request('/divideFeeType/save', {
    method: 'POST',
    data: params,
  });
}
// divideFeeType/del/{id} — 删除
export function delDivideFeeType(params) {
  return Request(`/divideFeeType/del/${params.id}`, {
    method: 'POST',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/sys.api.js